export default __webpack_public_path__ + "static/media/expire-modal-image.ea246561.png";